var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntitlementW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25368 0.852539H7.44337C9.70859 0.852539 10.8426 0.852539 11.6292 1.40703C11.8543 1.56546 12.0544 1.75446 12.2233 1.96639C12.8125 2.7071 12.8125 3.77301 12.8125 5.9062V7.67461C12.8125 9.73345 12.8125 10.7632 12.4866 11.5852C11.9627 12.9075 10.8551 13.9498 9.45011 14.4432C8.57668 14.7496 7.48367 14.7496 5.29489 14.7496C4.04554 14.7496 3.42017 14.7496 2.92127 14.5745C2.11871 14.2924 1.4857 13.6969 1.18622 12.9416C1 12.4719 1 11.8833 1 10.7069V7.80107",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.813 7.80107C12.813 8.4153 12.569 9.00436 12.1346 9.43869C11.7003 9.87301 11.1112 10.117 10.497 10.117C10.0342 10.117 9.48878 10.0364 9.03921 10.1566C8.84286 10.2094 8.66382 10.3129 8.52004 10.4567C8.37626 10.6005 8.27279 10.7795 8.21998 10.9759C8.09977 11.4254 8.18038 11.9709 8.18038 12.4337C8.18038 12.7378 8.12047 13.0389 8.00408 13.3199C7.8877 13.6009 7.71711 13.8562 7.50205 14.0713C7.287 14.2863 7.03169 14.4569 6.7507 14.5733C6.46972 14.6897 6.16856 14.7496 5.86443 14.7496M1.69531 2.58967C2.03718 2.23808 2.94605 0.852539 3.43244 0.852539M3.43244 0.852539C3.91884 0.852539 4.82771 2.23808 5.16958 2.58967M3.43244 0.852539V6.41136",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitlementW);
export default __webpack_public_path__ + "static/media/EntitlementW.7a69210022ccff9ee062f878c77bbfdb.svg";
export { ForwardRef as ReactComponent };